import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Swal from "sweetalert2";
import ProductServices from "../../../services/ProductServices";
import * as XLSX from "xlsx";

const DirectiveReport = () => {
    const [open2, setOpen2] = useState(true);
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [expandedRow, setExpandedRow] = useState(null); // Track expanded row

    useEffect(() => {
        setLoading(true);
        ProductServices.getDirectiveReoprtAll()
            .then((response) => {
                setReportData(response.data);
                setLoading(false);
            })
            .catch((error) => {
                Swal.fire({
                    icon: "error",
                    title: "Fetch Error",
                    text: "Failed to fetch report data. Please try again later.",
                });
                console.error("Error fetching directive report:", error);
                setLoading(false);
            });
    }, []);

    const sortedReportData = useMemo(() => {
        return reportData.sort((a, b) => {
            if (a.partNo < b.partNo) return -1;
            if (a.partNo > b.partNo) return 1;
            return 0;
        });
    }, [reportData]);

    const filteredData = useMemo(() => {
        return sortedReportData.filter((item) => {
            const partNoMatch = String(item.partNo).toLowerCase().includes(searchTerm.toLowerCase());
            const descriptionMatch = item.description ? item.description.toLowerCase().includes(searchTerm.toLowerCase()) : false;
            const categoryMatch = item.category ? item.category.name.toLowerCase().includes(searchTerm.toLowerCase()) : false;

            return partNoMatch || descriptionMatch || categoryMatch;
        });
    }, [sortedReportData, searchTerm]);

    const toggleChildTable = (index) => {
        setExpandedRow(expandedRow === index ? null : index); // Toggle expanded row
    };

    const downloadExcel = () => {
        if (reportData.length === 0) {
            Swal.fire({
                icon: "info",
                title: "No Data",
                text: "No data available to download.",
            });
            return;
        }

        const formattedData = reportData.map((item) => ({
            "Part No": item.partNo,
            "Description": item.description,
            "Category": item.category ? item.category.name : "N/A",
            "Unit": item.unit ? item.unit.name : "N/A",
            "Total Current Stock": Number.isInteger(item.totalCurrentStock)
                ? item.totalCurrentStock
                : item.totalCurrentStock.toFixed(2),
        }));

        const now = new Date();
        const date = now.toISOString().split("T")[0];
        const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
        const fileName = `Directors_Report_${date}_${time}.xlsx`;

        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Directive Report");

        XLSX.writeFile(workbook, fileName);
        Swal.fire({
            icon: "success",
            title: "Download Successful",
            text: `File "${fileName}" has been downloaded successfully.`,
        });
    };

    return (
        <>
            <div className="col-xl-12">
                <div className="filter cm-content-box box-primary">
                    <div className={`content-title`}>
                        <div className="cpa">
                            <i className="fas fa-filter me-2"></i>Filter
                        </div>
                        <div className="tools">
                            <Link
                                to={"#"}
                                className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                                onClick={() => setOpen2(!open2)}
                            >
                                <i className="fas fa-angle-up"></i>
                            </Link>
                        </div>
                    </div>
                    <Collapse in={open2}>
                        <div className="cm-content-body form excerpt">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-3 col-xxl-12">
                                        <input
                                            type="text"
                                            className="form-control mb-xl-0 mb-3"
                                            placeholder="Search by Part No., Category, or Description"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Collapse>
                </div>
                <div className="filter cm-content-box box-primary">
                    <div className="content-title">
                        <div className="cpa">
                            <i className="fa fa-list me-2" aria-hidden="true"></i>Director Report
                        </div>
                       
                        <div className="tools">
                        
                        </div>
                    </div>
                    <div className="cm-content-body form excerpt">
                        <div className="card-body">
                        <div className="mb-3 text-end">
                                {!loading && reportData?.length > 0 ? (
                                    <p   onClick={downloadExcel} className="text-end btn btn-rounded btn-md btn-primary me-3">
                                        <i className="las la-download scale5 me-3"></i> Download Report
                                    </p>
                                ) : (
                                    <p></p>
                                )}

                            </div>
                            <div className="table-responsive">
                                {loading ? (
                                    <div className="loader-container">
                                        <div className="loader"></div>
                                        <p>Loading Report...</p>
                                    </div>
                                ) : (
                                    <table className="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Part No</th>
                                                <th>Description</th>
                                                <th>Category</th>
                                                <th>Unit</th>
                                                <th>Total Stock</th>
                                                <th className="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredData.length > 0 ? (
                                                filteredData.map((item, index) => (
                                                    <React.Fragment key={item._id}>
                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td>{item.partNo}</td>
                                                            <td className="scrollable-description">{item.description}</td>
                                                            <td>{item.category ? item.category.name : "N/A"}</td>
                                                            <td>{item.unit ? item.unit.name : "N/A"}</td>
                                                            <td className="text-center">{item.totalCurrentStock}</td>
                                                            <td className="text-center" style={{
                                                                
                                                                    height:"40px", /* Adjust the height as needed */
                                                                    width: '40px',  /* Adjust the width as needed */
                                                                    
                                                                  
                                                                
                                                            }}>
                                                                
                                                                <button
                                                                    className="btn btn-primary btn-sm"
                                                                    onClick={() => toggleChildTable(index)}
                                                                >
                                                                    {expandedRow === index ? (
                                                                        "Hide Details"
                                                                    ) : (
                                                                        <>Show Details <span className="badge bg-dark ms-2">{item.totalCurrentStock}</span></>
                                                                    )}                                                                </button>
                                                            </td>
                                                        </tr>
                                                        {expandedRow === index && (
                                                            <tr>
                                                                <td colSpan="7" className="p-0">
                                                                    <div className="table-responsive mt-3">
                                                                        <table className="table table-bordered table-striped">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>S.No</th>
                                                                                    <th>Store Name</th>
                                                                                    <th>Location</th>
                                                                                    <th>Current Stock</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {item.stores && item.stores.length > 0 ? (
                                                                                    item.stores.map((store, storeIndex) => (
                                                                                        <tr key={store.storeId}>
                                                                                            <td>{storeIndex + 1}</td>
                                                                                            <td>{store.storeName}</td>
                                                                                            <td>{store.storeLocation}</td>
                                                                                            <td>{store.currentStock}</td>
                                                                                        </tr>
                                                                                    ))
                                                                                ) : (
                                                                                    <tr>
                                                                                        <td colSpan="4" className="text-center">
                                                                                            No data available
                                                                                        </td>
                                                                                    </tr>
                                                                                )}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center">
                                                        No data available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

            </div>


        </>
    );
};

export default DirectiveReport;
